export const category_palette = {
  FOOD: {
    background: '#FFEDF9',
    stroke: '#FF73CB',
    tag: '#FFC9EE',
  },
  TOUR: {
    background: '#EEF8FF',
    stroke: '#53ABF7',
    tag: '#B6E1FF',
  },
  ACCOM: {
    background: '#F7FEFB',
    stroke: '#01C99B',
    tag: '#E2F6EF',
  },
  ETC: {
    background: '#FEFBF7',
    stroke: '#D88435',
    tag: '#FFF4E8',
  },
};

export const categoryToKo = {
  FOOD: '음식',
  TOUR: '관광',
  ACCOM: '숙소',
  ETC: '기타',
};

export const categoryToEng = {
  음식: 'FOOD',
  관광: 'TOUR',
  숙소: 'ACCOM',
  기타: 'ETC',
};
